var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#019875",
    d: "M11.846 4.35l-6.092 5.766-2.6-2.461a1.313 1.313 0 0 0-1.784 0 1.15 1.15 0 0 0 0 1.69l3.492 3.305c.246.233.57.35.892.35.323 0 .646-.117.893-.35l6.983-6.61a1.15 1.15 0 0 0 0-1.69 1.312 1.312 0 0 0-1.784 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M-5-3h24v24H-5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV);
export default __webpack_public_path__ + "static/media/v.3cb195d2cff0d52c82f4f25a2b4ead63.svg";
export { ForwardRef as ReactComponent };